import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IGroupSpaceResource } from "../types";

export type IGroupSpaceReworkMutationParameters = { groupSpace: RelationalValue<IGroupSpaceResource> };

export const groupSpaceReworkMutation: IApiMutationFunction<IGroupSpaceReworkMutationParameters> = ({
    groupSpace,
}) => ({
    method: "PUT",
    url: `/group_spaces/${mapRelationalValue(groupSpace)}/rework`,
    data: {},
});

export const useGroupSpaceReworkMutation = createApiMutationHook<
    IGroupSpaceReworkMutationParameters,
    IGroupSpaceResource
>(groupSpaceReworkMutation);
